import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { LicenseService } from '../services/http-services/license.service';
import { LicenseStatusModel } from '../models/view-models/license-models/license-status.model';

@Injectable({
  providedIn: 'root'
})
export class FeatureRestrictionGuard  {

  constructor(
    private readonly licenseService: LicenseService,
    private readonly router: Router,
    private readonly toastr: ToastrService
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    const featureName: string = route.data.featureName;
    const isAllowedByTrialMode: boolean = JSON.parse(route.data.isAllowedByTrialMode);
    const errorMessage: string = route.data.errorMessage;
    this.licenseService.isStatusInPending.next(true);

    if (this.licenseService.licenseStatusModel) {
      return of(
        this.checkFeatureAccess(this.licenseService.licenseStatusModel, featureName, errorMessage, isAllowedByTrialMode)
      );
    } else {
      return this.licenseService.licenseStatusModel$.pipe(
        filter((licenseStatus: LicenseStatusModel) => !!licenseStatus),
        take(1),
        map((licenseStatus: LicenseStatusModel) => {
          if ((licenseStatus.AllowedFeatures && licenseStatus.AllowedFeatures.length) || isAllowedByTrialMode) {
            return this.checkFeatureAccess(licenseStatus, featureName, errorMessage, isAllowedByTrialMode);
          } else {
            return this.accessDenied(errorMessage);
          }
        })
      );
    }
  }

  private checkFeatureAccess(
    licenseStatus: LicenseStatusModel, featureName: string, errorMessage: string, isAllowedByTrialMode: boolean
  ): boolean {
    let isCurrentFeatureAllowed: boolean = _.some(licenseStatus.AllowedFeatures, (allowedFeatureName: string) =>
      allowedFeatureName.toLowerCase().includes(featureName.toLowerCase()));
      const isTrialMode: boolean = !licenseStatus.IsLicensed && licenseStatus.EvaluationDaysLeft > 0;

    if (isAllowedByTrialMode && isTrialMode) {
      isCurrentFeatureAllowed = licenseStatus.Status && !licenseStatus.IsLicensed;
    }

    if (isCurrentFeatureAllowed) {
      this.licenseService.isStatusInPending.next(false);
      this.licenseService.isAllowToInnitFeature.next(true);
      return true;
    } else {
      return this.accessDenied(errorMessage);
    }
  }

  private accessDenied(errorMessage: string): boolean {
    this.licenseService.isAllowToInnitFeature.next(false);
    this.licenseService.isStatusInPending.next(false);
    this.router.navigate(['/']);
    this.toastr.error(errorMessage);

    return false;
  }
}
